module.exports = __webpack_public_path__ + "img/dolar.91944ef5.svg";